var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "avatar" }, [
    _vm.url
      ? _c("span", {
          staticClass: "img",
          style: { backgroundImage: "url(" + _vm.url + ")" },
        })
      : _c(
          "span",
          {
            staticClass: "letters",
            style: "background-color:" + _vm.stringToHslColor(50, 50),
          },
          [_vm._v(_vm._s(_vm.nameTag()))]
        ),
    _vm._v(" "),
    !_vm.condensed
      ? _c("div", { staticClass: "meta" }, [
          !_vm.hideName && (_vm.firstName || _vm.lastName)
            ? _c("div", { staticClass: "name" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.firstName) +
                    "\n            " +
                    _vm._s(_vm.lastName) +
                    "\n        "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.hideEmail
            ? _c("div", { staticClass: "email" }, [
                _vm._v("\n            " + _vm._s(_vm.email) + "\n        "),
              ])
            : _vm._e(),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }